export default __webpack_public_path__ + "static/media/gwn30.d818cd46.webp";